import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';

export const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 564,
    },
    '& .modal-base-content': {
        padding: '24px 16px',
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '16px 24px',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
        gridGap: '8px',
    },
});

export const PermissionRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 0',
    gap: 16,
    '& > :first-of-type': {
        flex: '0 0 auto',
        minWidth: 140,
    },
    '& > :last-child': {
        flex: 1,
        maxWidth: 280,
    },
});

export const TabPanel = styled('div')({
    gridColumn: '1 / span 2',
    marginBottom: 8,
    '@media (max-width: 768px)': {
        gridColumn: 'auto',
    },
});

export const MembersList = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginTop: 16,
});

export const MemberRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minHeight: 40,
    padding: '0 12px',
    borderRadius: 8,
    border: '1px solid var(--divider)',
});
